<div class="partner-info">
    <!-- Form Content -->
    <form nz-form nzLayout="vertical" [formGroup]="form" (keydown.enter)="$event.preventDefault()">
      <!-- Internal Information Section -->
      <div class="sectionTitle">
        <fa-icon icon="info"></fa-icon>
        Internal Information
      </div>
      
      <nz-row nzGutter="16">
        <!-- Partner Name -->
        <nz-col nzLg="6" nzMd="6" nzSm="24">
          <nz-form-item>
            <nz-form-label nzRequired>Partner Name</nz-form-label>
            <nz-form-control [nzErrorTip]="'Partner name is required'">
              <input formControlName="name" nz-input placeholder="Enter partner name"
                     [maxlength]="256" autocomplete="off" required>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
  
        <!-- Platform Fee -->
        <nz-col nzLg="6" nzMd="6" nzSm="24">
          <nz-form-item>
            <nz-form-label nzRequired>Platform Fee</nz-form-label>
            <nz-form-control [nzErrorTip]="'Platform fee is required'">
              <nz-input-group nzAddOnAfter="%">
                <nz-input-number
                  formControlName="platformFee"
                  [nzStep]="1"
                  [nzPrecision]="2"
                  [nzMin]="0"
                  [nzMax]="99.99"
                  [nzPlaceHolder]="'Enter platform fee'"
                ></nz-input-number>
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
  
        <!-- Platform Fee Type -->
        <nz-col nzLg="6" nzMd="6" nzSm="24">
          <nz-form-item>
            <nz-form-label nzRequired>Platform Fee Type</nz-form-label>
            <nz-form-control [nzErrorTip]="'Platform fee type is required'">
              <nz-select
                formControlName="platformFeeType"
                nzPlaceHolder="Select platform fee type"
                class="full-width">
                <nz-option 
                  *ngFor="let option of platformFeeOptions"
                  [nzValue]="option.value"
                  [nzLabel]="option.displayName">
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <!-- Default Demand Margin -->
        <nz-col nzLg="6" nzMd="6" nzSm="24">
          <nz-form-item>
            <nz-form-label>Default Client Margin</nz-form-label>
            <nz-form-control [nzErrorTip]="demandMarginValidationsTpl">
                <ng-template #demandMarginValidationsTpl>
                  <ng-container *ngIf="form.get('defaultDemandMargin')?.hasError('marginRange')">
                    {{form.get('defaultDemandMargin')?.errors['marginRange']}}
                  </ng-container>
                </ng-template>
                <nz-input-group [nzAddOnAfter]="'%'">
                  <nz-input-number
                    id="defaultDemandMargin"
                    formControlName="defaultDemandMargin"
                    style="width: 100%"
                    [nzStep]="1"
                    [nzPrecision]="0"
                    nzPrecisionMode="cut"
                    [nzPlaceHolder]="'Enter a client margin'">
                  </nz-input-number>
                </nz-input-group>
              </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>

      <!-- Partner Type + Parent Partner -->
      <nz-row nzGutter="16">
        <nz-col nzLg="6" nzMd="6" nzSm="24" *ngIf="showPartnerType">
          <nz-form-item>
            <nz-form-label nzRequired>Partner Type</nz-form-label>
            <nz-form-control>
              <nz-select
                formControlName="partnerType"
                id="partner-type"
                data-testid="partner-type"
                [nzDisabled]="mode !== 'create'"
                (ngModelChange)="onPartnerTypeChange()"
                nzPlaceHolder="Select partner type">
                <nz-option [nzValue]="PartnerType.CURATOR" [nzLabel]="partnerTypeLabels.CURATOR"></nz-option>
                <nz-option [nzValue]="PartnerType.AGENCY" [nzLabel]="partnerTypeLabels.AGENCY"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col nzLg="6" nzMd="6" nzSm="24" *ngIf="showParentPartner">
          <nz-form-item>
            <nz-form-label>Parent Partner</nz-form-label>
            <nz-form-control>
              <nz-select
                formControlName="parentPartnerId"
                id="parent-partner-id"
                data-testid="parent-partner-id"
                [nzDisabled]="mode !== 'create' || !isAgency"
                nzAllowClear
                nzShowSearch>
                <nz-option *ngFor="let agency of parentAgencyOptions" [nzValue]="agency.id" [nzLabel]="agency.name"></nz-option>
              </nz-select>
              <div *ngIf="mode === 'create' && isAgency" class="helper-text">
                Leave blank for a top-level partner
              </div>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col nzLg="12" nzMd="12" nzSm="24" *ngIf="mode !== 'create' && childPartners?.length">
          <nz-form-item>
            <nz-form-label>Child Agencies ({{ childPartners.length }})</nz-form-label>
            <nz-form-control>
              <a *ngFor="let child of childPartners"
                 class="margin-right-small"
                 target="_blank" rel="noopener noreferrer"
                 [routerLink]="[partnerEditBaseRoute, child.id, childLinkSuffix]">
                <nz-tag class="partner-type-agency">{{ child.name }}</nz-tag>
              </a>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>

      <ng-container *ngIf="mode !== 'disabled'">
        <nz-row nzGutter="16">
          <!-- Internal Notes -->
          <nz-col nzLg="24" nzMd="24" nzSm="24">
            <nz-form-item>
              <nz-form-label>Internal Notes</nz-form-label>
              <nz-form-control>
                <textarea formControlName="notes" 
                         nz-input 
                         [nzAutosize]="{ minRows: 4, maxRows: 6 }"
                         placeholder="Enter internal notes">
                </textarea>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
        </nz-row>
      </ng-container>
  
      <!-- Audience Section -->
      <div class="sectionTitle">
        <fa-icon icon="users"></fa-icon>
        Audiences
      </div>
      <nz-row nzGutter="16">
        <nz-col nzLg="24" nzMd="24" nzSm="24">
          <nz-form-item>
            <nz-form-label>Audience Providers</nz-form-label>
            <nz-form-control>
              <nz-select
                formControlName="audienceProviders"
                class="full-width"
                nzMode="multiple"
                nzPlaceHolder="Select providers"
                nzShowArrow="true"
                nzShowSearch>
                <nz-option 
                  *ngFor="let provider of dmpAudienceProviders" 
                  [nzLabel]="mode !== 'disabled' ? provider.providerName + ' (id: ' + provider.providerId + ')' : provider.providerName"
                  [nzValue]="provider.providerId">
                  {{ provider.providerName }} (id: {{ provider.providerId }})
                  <small class="provider-source">({{ provider.sourceDmp }})</small>
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>
    </form>
  </div>

  <ng-template #hiddenFields></ng-template>
  <ng-template #hiddenNotes></ng-template>